import React from 'react';
import { connect } from 'react-redux';
import PassageTextFeedback from '../../utils/feedback/passageTextFeedback';

const mapStateToProps = (state) => {
    const {
        rightFeedbackProps,
        leftFeedbackProps,
    } = state.rootReducer.testPageDetails;

    return {
        rightFeedbackProps,
        leftFeedbackProps,
    }
}

const WordCloudCorrectFeedback = ({
    rightFeedbackProps: {
        correctAnswer,
        textCorrectAnswer,
        passage,
    },
     leftFeedbackProps: {
        selectedAnswer,
    },
}) => {
    textCorrectAnswer = !!textCorrectAnswer ? textCorrectAnswer : correctAnswer;

    return (
        <span>
              <h4 class="text-success">That's Correct</h4>              
              <div class="quiz-area-answer">                 
                <div class="display-flex align-center">
                    <div class="bord-right col-md-3">
                       <h4 class="text-success text-right">Your answer</h4>
                    </div>
                      <PassageTextFeedback passage={passage}  correctAnswer={ textCorrectAnswer} selectedAnswer={ textCorrectAnswer}/>
                </div>                    
            </div>
        </span>
    )

}



export default connect(mapStateToProps)(WordCloudCorrectFeedback);